export function parseCurrentDateFromMs(ms: string | number): Date {
	return new Date(Number(ms));
}
